import React from 'react';
import { Link } from 'react-router-dom';

import styles from './CookieConsentModal.module.css';

import { useCookieConsent } from '@/shared/hooks/useCookieConsent';
import { PUBLIC_ROUTES } from '@/shared/constants';

export const CookieConsentModal: React.FC = () => {
  const { hasConsentedToCookies, acceptCookieConsent } = useCookieConsent();

  if (hasConsentedToCookies) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <p className={styles.message}>
            We use cookies to ensure you can access your lessons and to analyze our traffic. By continuing to use our site, you agree to our use of cookies as outlined in our{' '}
            <Link to={PUBLIC_ROUTES.COOKIE_POLICY} className={styles.link}>
              Cookie Policy
            </Link>
            .
          </p>
        </div>
        <button
          className={styles.acceptButton}
          onClick={acceptCookieConsent}
          aria-label="Accept cookies and continue"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsentModal;
